// // src/App.js
// import React, { useState, useEffect } from 'react';
// import Header from './components/Header/Header';
// import Hero from './components/Hero/Hero';
// import About from './components/About/About';
// import Skills from './components/Skills/Skills';
// import Projects from './components/Projects/Projects';
// import Contact from './components/Contact/Contact';
// import Footer from './components/Footer/Footer';
// import './App.css';

// function App() {
//   const [activeSection, setActiveSection] = useState('home');

//   useEffect(() => {
//     const handleScroll = () => {
//       const sections = document.querySelectorAll('section');
//       sections.forEach(section => {
//         const sectionTop = section.offsetTop;
//         if (window.scrollY >= sectionTop - 100) {
//           setActiveSection(section.getAttribute('id'));
//         }
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToSection = (sectionId) => {
//     const section = document.getElementById(sectionId);
//     if (section) {
//       window.scrollTo({
//         top: section.offsetTop - 80,
//         behavior: 'smooth'
//       });
//     }
//   };

//   return (
//     <div className="App">
//       <Header 
//         activeSection={activeSection} 
//         scrollToSection={scrollToSection} 
//       />
//       <Hero />
//       <About />
//       <Skills />
//       <Projects />
//       <Contact />
//       <Footer />
//     </div>
//   );
// }

// export default App;



// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import ProjectDetails from './components/Projects/ProjectDetails';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

const AppContent = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'skills', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={
          <div className="portfolio">
            <Header 
              activeSection={activeSection} 
              scrollToSection={scrollToSection} 
            />
            <main>
              <Hero scrollToSection={scrollToSection} />
              <About />
              <Skills />
              <Projects />
              <Contact />
            </main>
            <Footer />
          </div>
        } />
        <Route path="/project/:id" element={<ProjectDetails />} />
        <Route path="*" element={
          <div className="not-found">
            <h1>404 - Page Not Found</h1>
            <a href="/" className="back-home">Go Back Home</a>
          </div>
        } />
      </Routes>
    </div>
  );
};

export default App;